<h2 mat-dialog-title>Comitato</h2>
<div mat-dialog-content class="dialog-center-cont">
  <form [formGroup]="formComitati" appFormContainer [larghezza]="2">
    <mat-form-field appFormElement [larghezza]="2" [riempi]="true">
      <mat-label>Nome Comitato</mat-label>
      <input matInput placeholder="Nome Comitato" formControlName="descrizione" />
      <mat-error appFormError></mat-error>
    </mat-form-field>

    <mat-form-field appFormElement [larghezza]="2" [riempi]="true" *ngIf="!data?.idAzienda">
      <mat-label>Guida alla Scrittura</mat-label>
      <textarea
        matInput
        placeholder="Guida alla Scrittura"
        formControlName="guidaAllaScrittura"
        [rows]="5"
      ></textarea>
      <mat-error appFormError></mat-error>
    </mat-form-field>
  </form>
</div>
<div mat-dialog-actions class="dialog-footer-cont">
  <div>
    <button mat-dialog-close mat-flat-button color="accent" class="accent-button">Chiudi</button>
  </div>
  <div>
    <button mat-flat-button color="primary" (click)="salva()" class="primary-button">Salva</button>
  </div>
</div>
